export default "__VITE_ASSET__BfdkCwk1__"